// Sanity.io icon set (MIT) -- a clock hand inside a counter-clockwise arrow:
// "put this back to how it was at that time", which is exactly what the button
// it sits on does.
//
// Two changes from the source file. The stroke is currentColor rather than a
// baked #121923, so the icon takes the button's green and dims with it under
// disabled:opacity-50 instead of staying black on a faded button. And the width
// is 1.6 rather than 1.2: this art is drawn on a 25 viewBox where the icon
// beside it (EyesIcon, on Details) is drawn on 24 at 1.5, so at the 14px both
// render at, 1.2 would come out visibly fainter than its neighbour.
export const RestoreIcon = (props) => (
  <svg fill="none" height={16} viewBox="0 0 25 25" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.88468 17C7.32466 19.1128 9.75033 20.5 12.5 20.5C16.9183 20.5 20.5 16.9183 20.5 12.5C20.5 8.08172 16.9183 4.5 12.5 4.5C8.08172 4.5 4.5 8.08172 4.5 12.5V13.5M12.5 8V12.5L15.5 15.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    />
    <path d="M7 11L4.5 13.5L2 11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.6} />
  </svg>
);
